/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Integrations({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M4.975 3.125a2.225 2.225 0 0 1 4.45 0V3.5h.07c.437 0 .795 0 1.088.02.302.02.578.065.843.174a2.55 2.55 0 0 1 1.38 1.38c.11.265.153.54.174.843q.014.226.018.508h.377a2.225 2.225 0 0 1 0 4.45H13v.53c0 .525 0 .955-.029 1.305-.03.362-.092.69-.249.998a2.55 2.55 0 0 1-1.114 1.114c-.308.157-.636.22-.998.25-.35.028-.78.028-1.305.028h-.48a.6.6 0 0 1-.6-.6v-1.137a.862.862 0 1 0-1.725 0V14.5a.6.6 0 0 1-.6.6h-.805c-.525 0-.955 0-1.305-.029-.362-.03-.69-.092-.998-.249a2.55 2.55 0 0 1-1.114-1.114c-.157-.308-.22-.636-.25-.998-.028-.35-.028-.78-.028-1.305v-.155c0-.87.705-1.575 1.575-1.575a1.025 1.025 0 1 0 0-2.05c-.852 0-1.608-.695-1.561-1.606.017-.344.059-.652.18-.945a2.55 2.55 0 0 1 1.38-1.38c.265-.11.54-.153.843-.174.293-.02.65-.02 1.087-.02h.071zM7.2 2.1c-.566 0-1.025.459-1.025 1.025V4.1a.6.6 0 0 1-.6.6h-.65c-.463 0-.78 0-1.026.017-.242.017-.372.047-.466.086-.33.137-.593.4-.73.73-.044.105-.076.253-.09.548-.01.165.137.344.362.344a2.225 2.225 0 1 1 0 4.45.375.375 0 0 0-.375.375v.13c0 .556 0 .937.025 1.232.023.288.066.441.122.55.13.255.336.461.59.59.11.057.263.1.551.123.295.024.676.025 1.232.025h.18v-.537a2.062 2.062 0 1 1 4.125 0v.537c.478 0 .818-.003 1.087-.025.288-.023.441-.066.55-.122.255-.13.461-.336.59-.59.057-.11.1-.263.123-.551.024-.295.025-.676.025-1.232v-1.105a.6.6 0 0 1 .6-.6h.975a1.025 1.025 0 1 0 0-2.05H12.4a.6.6 0 0 1-.6-.6c0-.463 0-.78-.017-1.026-.017-.242-.047-.372-.086-.466a1.35 1.35 0 0 0-.73-.73c-.094-.04-.225-.07-.466-.086A17 17 0 0 0 9.475 4.7h-.65a.6.6 0 0 1-.6-.6v-.975c0-.566-.459-1.025-1.025-1.025" clipRule="evenodd" /></svg>;
}
;